import { useEditorLotusAvailable } from '@/hooks/editor/useEditorLotusAvailable'
import { useEditorLotusEnabled } from '@/hooks/editor/useEditorLotusEnabled'
import { useEditorPageSetTurnedOver } from '@/hooks/editor/useEditorPageSetTurnedOver'

/**
 * Whether a text insert makes a Lotus text box here: the toolbar's text
 * button, a custom verse and a service template saved as HTML all ask, and
 * all follow one rule: Lotus is available for the open order's funeral home
 * (`useEditorLotusAvailable`), and either the page set is turned over, for
 * every user, or the staff switch reads on (`useEditorLotusEnabled`, which
 * reads off for everyone but internal staff where Lotus is offered). Anywhere
 * else the insert makes a TinyMCE box, a turned-over page set at a funeral
 * home the limit does not list included. A duplicate or a paste keeps its
 * source's kind and does not ask. A service template saved as a Lotus
 * arrangement always inserts a Lotus box, so the insert menu lists it only
 * where this rule makes Lotus. The page shuffler's floral title, which no
 * menu opens, stays a TinyMCE box.
 */
export const useEditorInsertsLotus = (): boolean => {
  const available = useEditorLotusAvailable()
  const turnedOver = useEditorPageSetTurnedOver()
  const [switchOn] = useEditorLotusEnabled()
  return available && (turnedOver || switchOn)
}
